import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import "./styles/theme.css";

import Navbar from "./components/Navbar";

import Home from "./pages/Home";
import Bikes from "./pages/Bikes";
import Contact from "./pages/Contact";
import Taxi from "./pages/Texi";
import Horse from "./pages/Horse";
import Footer from "./components/BottomNav";
/* =====================================================
   SCROLL TO TOP
====================================================== */

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [pathname]);

  return null;
}

/* =====================================================
   NOT FOUND PAGE
====================================================== */

function NotFound() {
  return (
    <main
      className="not-found-page"
      style={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "40px 20px",
      }}
    >
      <h1>Page Not Found</h1>

      <p>
        The page you are looking for does not exist.
      </p>

      <a
        href="/"
        style={{
          marginTop: "20px",
          textDecoration: "none",
          fontWeight: "600",
        }}
      >
        Go Back to VK Bike On Rent
      </a>
    </main>
  );
}

/* =====================================================
   APP
====================================================== */

function AppRoutes() {
  return (
    <>
      <ScrollToTop />

      <Navbar />

      <Routes>

        {/* =========================
            HOME
        ========================== */}

        <Route
          path="/"
          element={<Home />}
        />

        {/* =========================
            BIKE & SCOOTY RENTAL
        ========================== */}

        <Route
          path="/bikes"
          element={<Bikes />}
        />

        {/* =========================
            TAXI & CAB SERVICES
        ========================== */}

        <Route
          path="/taxi"
          element={<Taxi />}
        />

        {/* =========================
            HORSE RIDING
        ========================== */}

        <Route
          path="/horse-riding"
          element={<Horse />}
        />

        {/* =========================
            CONTACT
        ========================== */}

        <Route
          path="/contact"
          element={<Contact />}
        />

        {/* =========================
            404
        ========================== */}

        <Route
          path="*"
          element={<NotFound />}
        />

      </Routes>
    </>
  );
}

/* =====================================================
   ROOT APP
====================================================== */

function App() {
  return (
    <Router>
      <AppRoutes />
      <Footer />
    </Router>
  );
}

export default App;